import { render } from "./chatHistory.vue?vue&type=template&id=e1bc3fae"
import script from "./chatHistory.vue?vue&type=script&lang=js"
export * from "./chatHistory.vue?vue&type=script&lang=js"

import "./chatHistory.vue?vue&type=style&index=0&id=e1bc3fae&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_im/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__